export function normalizeAuthEmail(email) {
  return String(email || "")
    .trim()
    .toLowerCase();
}

export function googleEmailMatchesAccount(googleEmail, accountEmail) {
  const google = normalizeAuthEmail(googleEmail);
  const account = normalizeAuthEmail(accountEmail);
  return !!google && !!account && google === account;
}

export function googleProviderEmail(user) {
  const google = (user?.providerData || []).find(
    (p) => p?.providerId === "google.com"
  );
  return normalizeAuthEmail(google?.email || user?.email);
}

export function googleLinkErrorMessage(error) {
  const code = error?.code || "";
  if (
    code === "auth/popup-closed-by-user" ||
    code === "auth/cancelled-popup-request"
  ) {
    return null;
  }
  if (code === "auth/popup-blocked") {
    return "Allow popups to connect Google.";
  }
  if (
    code === "auth/credential-already-in-use" ||
    code === "auth/email-already-in-use" ||
    code === "auth/account-exists-with-different-credential"
  ) {
    return "That Google account is already used on another login. Choose the Google account that matches this email.";
  }
  if (code === "auth/provider-already-linked") {
    return null;
  }
  return error?.message || "Could not connect Google. Try again.";
}
